import React from 'react';

const ParkIcon = (props) => {
  return (
    <img
      alt="Góra"
      src="/static/images/icons/place_types/park.svg"
      {...props}
    />
  );
};

export default ParkIcon;
